import { CheckIcon, ReportsIcon } from '@panwds/icons';
import React, { useEffect, useState } from 'react';
import { ProgressRing } from '../Icon/index.js';
import { Button } from './Button.js';
const defaultProps = {
    dataResult: { loading: false, success: false },
    progress: 0,
    appearance: 'secondary',
    disabled: false,
    size: 'md'
};
export function ProgressButton({ children, onClickCallback, dataResult, appearance, disabled, size, addClassName, progress, ...passThrough }) {
    const { loading, success } = dataResult;
    const [isLoading, setIsLoading] = useState(false);
    const [click, setClick] = useState(false);
    const handleClick = () => {
        setIsLoading(true);
        setClick(true);
        onClickCallback?.();
    };
    useEffect(() => {
        if (loading) {
            setIsLoading(false);
        }
    }, [dataResult]);
    const icon = isLoading ? (React.createElement(ProgressRing, { radius: 9.5, stroke: 2, progress: progress, appearance: appearance })) : click && success ? (React.createElement(CheckIcon, { size: size, className: "tw-animate-fadeIn tw-text-teal" })) : (React.createElement(ReportsIcon, { size: size, className: "tw-animate-fadeIn" }));
    return (React.createElement(Button, { isLoading: isLoading, icon: icon, onClick: handleClick, appearance: appearance, disabled: disabled, size: size, addClassName: addClassName, ...passThrough }, children));
}
ProgressButton.defaultProps = defaultProps;
ProgressButton.displayName = 'ProgressButton';
//# sourceMappingURL=ProgressButton.js.map